import { Center, Flex, Heading, Link, SimpleGrid } from '@chakra-ui/layout';
import { useBreakpointValue } from '@chakra-ui/media-query';
import { motion } from 'framer-motion';
import React from 'react';
import { BackgroundImage } from '../BackgroundImage';
import { FitnesslyLogo } from '../FitnesslyLogo';

const MotionHeading = motion(Heading);
interface AuthContainerProps {
  title: string;
  subtitle: string;
  icon?: JSX.Element;
}

export const AuthContainer: React.FC<AuthContainerProps> = ({
  title,
  subtitle,
  children,
  icon,
}) => {
  const isTableOrBelow = useBreakpointValue([true, true, false]);
  return (
    <SimpleGrid columns={[1, 1, 2]} gap={10} w="full">
      <Center flexDirection="column">
        {!isTableOrBelow && (
          <>
            {icon && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                exit={{ opacity: 0, transition: { duration: 0.2 } }}
              >
                {icon}
              </motion.div>
            )}
            <MotionHeading
              mt={1}
              textAlign="center"
              textTransform="uppercase"
              color="white"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              exit={{ opacity: 0, transition: { duration: 0.2, delay: 0.1 } }}
            >
              {title}
            </MotionHeading>
            <MotionHeading
              textAlign="center"
              size="md"
              mt={3}
              color="white"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              exit={{ opacity: 0, transition: { duration: 0.2, delay: 0.2 } }}
            >
              {subtitle}
            </MotionHeading>
          </>
        )}
      </Center>
      <Flex direction="column" align="center">
        {children}
        <Link
          mt={4}
          href="https://app-akrobaten.de/"
          target="_blank"
          color="white"
        >
          powered by{' '}
          <FitnesslyLogo ml={1} width="4.5em" height="2em" fill="white" />
        </Link>
      </Flex>
      <BackgroundImage />
    </SimpleGrid>
  );
};
